import React from 'react';
import PropTypes from 'prop-types';
import { useDeleteProduct } from '../../../Library/Hooks';
import { useAfterSuccess } from '../../../Hooks';

const DeleteProduct = ({ formID, formData, close }) => {
  const { request } = useAfterSuccess(useDeleteProduct(), close);

  const onSubmit = e => {
    e.preventDefault();
    request({ id: formData.id });
  };

  return <form id={formID} onSubmit={onSubmit} />;
};

DeleteProduct.propTypes = {
  formID: PropTypes.string.isRequired,
  formData: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number, PropTypes.shape({})])
  ).isRequired,
  close: PropTypes.func.isRequired
};

export default DeleteProduct;
